import { StoreSkuItem } from "@playroomkit/pr-wars-data";
import { ItemImage } from "../ShopComponents";
import Button from "@components/Button";
import { useMemo } from "react";

interface GameModeGridItemProps extends StoreSkuItem {
  onClick: (sku_id: string) => void;
  showPrice: (price: string | number) => string;
}

export const GameModeGridItem = (props: GameModeGridItemProps) => {
  const { sku_id, price, onClick, purchased, metadata, showPrice, free } =
    props;

  const label = useMemo(() => {
    if (free) return "Claimed";
    if (purchased) return "Purchased";
    if (!sku_id) return "Coming Soon";
    return null;
  }, [purchased, free, sku_id]);

  return (
    <div
      className={`relative w-full h-[23rem] transition col-span-full pt-4 ${
        !purchased ? "hover:scale-105" : ""
      }`}
      onClick={() => {
        if (purchased) return;
        onClick(sku_id ?? "");
      }}
    >
      <ItemImage
        src={metadata?.image ?? ""}
        className="size-full object-contain"
      />
      {(label || price) && (
        <div className="absolute bottom-8 right-16 min-w-40">
          <div className="rounded-xl p-1 inline-block bg-[#079902] shadow-[0_2px_0_0_#047A00] w-full">
            <Button className="font-[Slackey] border-none outline-none text-base rounded-lg px-4 py-1 flex items-center justify-center transition-all whitespace-nowrap text-black bg-[#31EC2A] w-full gap-4">
              {label ? (
                <span className="text-xl">{label}</span>
              ) : (
                <>
                  {(metadata as any)?.oldPrice && (
                    <div className="text-[#079902] text-2xl line-through">
                      ${(metadata as any).oldPrice}
                    </div>
                  )}
                  <div className="text-align">
                    <div className="text-3xl">{showPrice(price ?? "")}</div>
                  </div>
                </>
              )}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
